// @flow

export const SET_RESOURCE = 'Resource/SET_RESOURCE';
export const CLEAR_RESOURCE = 'Resource/CLEAR_RESOURCE';
export const MARK_ITEM_AS_DOWNLOADING = 'Resource/MARK_ITEM_AS_DOWNLOADING';

export const UPDATE_AVAILABLE_OFFLINE_START = 'Resource/UPDATE_AVAILABLE_OFFLINE_START';
export const UPDATE_AVAILABLE_OFFLINE_SUCCESS = 'Resource/UPDATE_AVAILABLE_OFFLINE_SUCCESS';
export const UPDATE_AVAILABLE_OFFLINE_FAILED = 'Resource/UPDATE_AVAILABLE_OFFLINE_FAILED';
export const SET_FAVOURITE_RESOURCE = 'Resource/SET_FAVOURITE_RESOURCE';


export function clearResource() {
    return {
        type: CLEAR_RESOURCE
    };
}

export function setResource( resource ) {
    return {
        resource: resource,
        type: SET_RESOURCE
    };
}

export function setFavouriteResource( isFav ) {
    return {
        isFav: isFav,
        type: SET_FAVOURITE_RESOURCE
    }
}

export function markItemAsDownloading( id, isDownloading, resource ) {

    // console.info( "markItemAsDownloading action", id, isDownloading, resource );

    return {
        id: id,
        isDownloading: isDownloading,
        resource: resource,
        type: MARK_ITEM_AS_DOWNLOADING
    };
}